export default __webpack_public_path__ + "static/media/rankpage-top2.9305782a.svg";